import React from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthConsumer } from "./AuthContext";
// import { hassecret } from "./auth";
import decode from "jwt-decode";
import Unauthorized from "./Unauthorized";

// const ProtectedRoute = ({ component: Component,layout: Layout, ...rest }) => (
//   <AuthConsumer>
//     {({ isAuth }) => (
//       <Route
//         render={props =>
//           (isAuth)||(localStorage.getItem('token')!==null) ? <Layout><Component {...props} /></Layout> : <Layout><Redirect to="/login" /></Layout>
//         }
//         {...rest}
//       />
//     )}
//   </AuthConsumer>
// )

// export default ProtectedRoute
import App from "./App";

// const {id,username,name,exp}= decode(localStorage.getItem('token'));
// console.log(id,username)
const ProtectedRoute = ({
  component: Component,
  layout: Layout,
  secret,
  ...rest
}) => (
  <AuthConsumer>
    {({ isAuth }) => (
      <Route
        render={
          (props) => {
            if (
              (isAuth || localStorage.getItem("token") !== null) &&
              secret === decode(localStorage.getItem("token")).role
            )
              return (
                <Layout>
                  <Component {...props} />{" "}
                </Layout>
              );
            else if (
              (isAuth || localStorage.getItem("token") !== null) &&
              secret === "normal"
            )
              return (
                <Layout>
                  <Component {...props} />{" "}
                </Layout>
              );
            else if (
              (isAuth || localStorage.getItem("token") !== null) &&
              secret !== decode(localStorage.getItem("token")).id
            )
              return (
                <App>
                  <Unauthorized />
                </App>
              );
            else return <Redirect to="/login" />;
          }

          //  : ((isAuth)||(localStorage.getItem('token')!==null)) &&(secret==='normal')? <Layout><Component {...props} />  </Layout>: ((isAuth)||(localStorage.getItem('token').trainee==='trianee')) ? <App><Unauthorized/></App> : (isAuth)||(localStorage.getItem('token')===null)? <Redirect to="/login" />:
        }
        {...rest}
      />
    )}
  </AuthConsumer>
);

export default ProtectedRoute;
